












































/**
 * Componente principal de la aplicación.
 *
 * ARCHIVO DEFINIDO EN REPOSITORIO CORE, NO SE DEBE MODIFICAR EN SATÉLITES PARTICULARES.
 */

import Vue from 'vue';
import Header from './components/layout/Header.vue';
import Footer from './components/layout/Footer.vue';
import ModalRegistro from './components/layout/ModalRegistro.vue';
import { mapGetters, mapMutations } from 'vuex';
import {
  LAYOUT_GETTER_MODAL_ACTIVO,
  LAYOUT_GETTER_SNACK_ACTIVO,
  LAYOUT_GETTER_LOADING,
  LAYOUT_MUTATION_CERRAR_MODAL,
  LAYOUT_MUTATION_OCULTAR_SNACKBAR,
  LAYOUT_MUTATIONS,
  LAYOUT_MUTATION_MOSTRAR_LOADING,
  LAYOUT_MUTATION_OCULTAR_LOADING,
} from './store/layout/layout.types';
import { USER_MUTATION_SET_USER } from './store/user/index.types';
import { User } from './models/User';
import {AUTH_SERVICE} from '@/services/auth.service';
import { trimUsuarioSales } from './views/acuerdo-comercial/acuerdo-comercial.helpers';

export default Vue.extend({
  name: 'App',
  components: {
    Header,
    Footer,
    ModalRegistro
  },
  data() {
    return {
      modal_registro: false
    };
  },
  /**
   * Se toma jwt almacenado previamente y si sigue siendo válido se utiliza para saltar el login, si no lo elimina y redirige a esa pantalla.
   */
  mounted() {
    this.$store.commit(LAYOUT_MUTATION_MOSTRAR_LOADING);
    AUTH_SERVICE.sesionActual()
      .then((sesion) => {
        let user = new User();
        let id_token = sesion.getIdToken();
        user.token_auth = id_token.getJwtToken();

        if (id_token.payload){
          user.email = id_token.payload.email;

          // Si en el payload existe el nombre, se lo asignó como nombre al usuario sino le asignó el usuario extraido del email.
          user.nombre = id_token.payload.name || trimUsuarioSales(user.email);
        }

        this.doOperacionAppMountedSatelite();

        this.$store.commit(USER_MUTATION_SET_USER, user);
      })
      .catch(() => {}) // El redirect a login se resuelve desde router.
      .finally(() => {
        this.$store.commit(LAYOUT_MUTATION_OCULTAR_LOADING);
      });
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    ...mapGetters({
      modal_activo: LAYOUT_GETTER_MODAL_ACTIVO,
      snack_activo: LAYOUT_GETTER_SNACK_ACTIVO,
      loading: LAYOUT_GETTER_LOADING
    })
  },
  methods: {
    /**
     * Inovado desde el template (evento cerrar del modal)
     */
    cerrarModalActivo() {
      this[LAYOUT_MUTATION_CERRAR_MODAL]();
    },
    /**
     * A completar en cada satelite
     */
    doOperacionAppMountedSatelite() {},
    /**
     * Inovado desde el template (evento hide del CaSnackbar)
     */
    ocultarSnackbarActivo() {
      this[LAYOUT_MUTATION_OCULTAR_SNACKBAR]();
    },
    ...mapMutations(LAYOUT_MUTATIONS)
  }
});
